import script from "./GenomicsTestResults.vue?vue&type=script&setup=true&lang=js"
export * from "./GenomicsTestResults.vue?vue&type=script&setup=true&lang=js"

import "./GenomicsTestResults.vue?vue&type=style&index=0&id=e279e3b2&lang=scss&scoped=true"
import "./GenomicsTestResults.vue?vue&type=style&index=1&id=e279e3b2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e279e3b2"]])

export default __exports__